export default "__VITE_ASSET__DwIJ5t7v__"